import { render, staticRenderFns } from "./payrollHistory.vue?vue&type=template&id=36f5dbc8&scoped=true"
import script from "./payrollHistory.vue?vue&type=script&lang=js"
export * from "./payrollHistory.vue?vue&type=script&lang=js"
import style0 from "./payrollHistory.vue?vue&type=style&index=0&id=36f5dbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5dbc8",
  null
  
)

export default component.exports